import React, { useEffect, useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Typography,
  TextField,
  Box,
  Grid,
  Paper,
} from "@mui/material";
import PaymentMethodStep from "../components/PaymentStep";
import AddTablesStep from "../components/AddTablesStep";
import AddMenuStep from "../components/AddMenuStep";
import FoodGroupCategories from "../components/FoodGroupCategories";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance";

// Main Account Page
const CompleteAccount = () => {
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const steps = ["Payment Method"];
  const [restaurantData, setRestaurantData] = useState({
    id:"",
    name: "",
    email: "",
    phone: "",
    paymentMethodIsAdded: false,
    accountStatus: "",
    address: "",
    tablesAdded: false,
    menuAdded: false,
    menuCategoriesAdded: false,
  });

  //Fetch restaurant data from local stroage

  useEffect(() => {
    const localUserData = JSON.parse(localStorage.getItem("user"));  

    if (localUserData) {
      setRestaurantData(localUserData);
    }
  }, []);

  // Determine the current active step based on restaurantData
  useEffect(() => {
    if (restaurantData.paymentMethodIsAdded) {
      setActiveStep(1);
    }
    if (restaurantData.tablesAdded) {
      setActiveStep(2);
    }
    if (restaurantData.menuCategoriesAdded) {
      setActiveStep(3);
    }
    if (restaurantData.menuAdded) {
      setActiveStep(4);
    }
  }, [restaurantData]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleFinish = () => {
    alert("Account setup completed!");

    //check local storage if menuadd is true, tablesadded is true and paymentmethodisadded is true navigate user to the dashboard
    const localUserData = JSON.parse(localStorage.getItem("user"));   

    if (localUserData.menuAdded && localUserData.tablesAdded && localUserData.paymentMethodIsAdded && localUserData.menuCategoriesAdded) {
        updateTheAccountStatusInDatabase();
      navigate("/dashboard"); 
    }
 

  };

  const updateTheAccountStatusInDatabase = async () => {
    try {
      const response = await axiosInstance.post("/api/restaurant/updateAccountStatus", {
        restaurantId: restaurantData.restaurantId,
        accountStatus: "completed",
      });
      if (response.status === 200) {
        console.log("Account status updated successfully");
      }
    } catch (error) {
      console.error("Error updating account status:", error);
    }
  }

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <PaymentMethodStep email={restaurantData.email} onNext={handleNext} />
        );
      case 1:
        return <AddTablesStep onNext={handleNext} />;
      case 2:
      return <FoodGroupCategories onFinish={handleNext} />;
      case 3:
        return <AddMenuStep onFinish={handleFinish} />;
      default:
        return "Unknown step";
    }
  };

  return (
    <Box sx={{ width: "100%", mt: 4 }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>
                {label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
        {activeStep === steps.length ? (
          <Typography variant="h5" align="center">
            All steps completed
          </Typography>
        ) : (
          <>
            {getStepContent(activeStep)}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              <button
                disabled={activeStep === 0 || activeStep === 1}
                onClick={handleBack}
                className={`px-4 py-2 font-bold text-white rounded-lg shadow-md transition-all duration-300 ease-in-out 
    ${
      activeStep === 0 || activeStep === 1
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-blue-500 hover:bg-blue-600 active:shadow-inner"
    }
  `}
              >
                Back
              </button>
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default CompleteAccount;
